@if(dialogDataService.dialogData()?.overlappingMeetings; as meetings){
<schedule-viewer-part [selectedSlots]="meetings.selectedMeetingSlots" [numMeetings]="meetings.numMeetings" [showApplicantTimeZone]="false"></schedule-viewer-part>

} @else {
<common-message alertType='info'>
	No Schedule Information Available
</common-message>
}